/* eslint-disable jsx-a11y/anchor-is-valid */
/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-02-07 15:26:55
 *
 *******************************************************/
// @flow

import _ from 'lodash';

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FullscreenBar, Card, Heading, Badge, Page, Button } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import PlansReview from 'src/components/views/subscription-v3/plans-review';
import PlansQA from 'src/components/views/subscription-v3/plans-qa';
import PackageCard from 'src/components/views/subscription-v3/package/package-card';
import PackageCardExpireExceed from 'src/components/views/subscription-v3/package/package-card.expire.exceed';
import StatusModal from 'src/components/views/subscription-v3/modal/status-modal';
import { routes } from 'src/routes';
import { PACKAGES, PLAN_STATUS } from 'src/constants/subscription';
import { showBeaconChat } from 'src/integrations/beacon';
import { formatNumberInThousand } from 'src/helpers';
import {
  enableNewPricingPageExceededUser,
  getSubscriptionStatus
} from 'src/helpers/subscription-v3-helper';
import {
  exitSABFullscreen,
  enterSABFullscreen
} from 'src/integrations/shopify-app-bridge/fullscreen';
import RenderNoticeStatus from 'src/components/views/subscription-v3/render-plan-notice-status';
import * as subscriptionV3Action from 'src/stores/actions/subscription-v3-actions';
import history from 'src/routes/history';

class PlanPackage extends Component<WithI18nProps> {
  unsubscribeExit = undefined;

  state = {
    activeSendRequestModal: false,
    openModalSubscribeFailure: false,
    planNumberRequest: null,
    packageSelected: ''
  };
  async componentDidMount() {
    const { getPackagePlans, getDetailInvoice, invoice, packagePlans } = this.props;
    // Get detail invoice
    if (_.isEmpty(invoice) || !invoice) {
      await getDetailInvoice();
    }
    // Get package list
    if (!_.get(packagePlans, 'basic', []).length) {
      await getPackagePlans();
    }

    const { planNumber } = this.props.match.params;
    this.setState({ planNumberRequest: planNumber });

    // Open modal success after subscribe and remove query statusSubscribe
    const search: string = _.get(history.location, 'search', '');
    if (_.includes(search, 'statusSubscribe=error')) {
      this.setState({ openModalSubscribeFailure: true });

      const removeSearch = search.replace('statusSubscribe=error', '');
      history.replace({ ...history.location, search: removeSearch });
    }

    // Active fullscreen
    this.unsubscribeExit = enterSABFullscreen(this.handleBack);
  }

  componentWillUnmount() {
    this.unsubscribeExit();
  }

  render() {
    const { openModalSubscribeFailure, planNumberRequest, packageSelected } = this.state;
    const {
      i18n,
      subscription = {},
      currentTotalProducts,
      packagePlans,
      confirmationUrl,
      gettingPackage,
      gettingInvoice,
      tenantApp,
      invoice
    } = this.props;
    const planStatus = i18n.translate(`AdminHTML.SubscriptionV3.PlanStatus.currentStatus`);
    const enableForExceededUser = enableNewPricingPageExceededUser(tenantApp);
    const subscriptionStatus = _.get(getSubscriptionStatus(tenantApp), 'status', '');
    const contentModalStatus = this.renderContentSubscribeError();

    return (
      <div className="BC-Page BC-Page__SubscriptionV3-Package">
        <FullscreenBar onAction={this.handleBack} />
        <Page>
          <div className="align-center card-title-uppercase">
            <Heading>{i18n.translate('AdminHTML.SubscriptionV3.Packages.title')}</Heading>
          </div>
          <div className="plan-notice-status">
            <RenderNoticeStatus subscription={subscription} tenantApp={tenantApp} />
          </div>

          <Card sectioned>
            <div className="planStatus">
              <Card sectioned>
                <div className="top">
                  <div className="status">
                    <div>{planStatus}</div>
                    <div>{this.renderStatus()}</div>
                  </div>

                  <div className="productCount">
                    <div>{i18n.translate('AdminHTML.SubscriptionV3.Packages.yourStore')}</div>
                    <div className="count">
                      {i18n.translate('AdminHTML.SubscriptionV3.Common.numberProducts', {
                        number: formatNumberInThousand(currentTotalProducts)
                      })}
                    </div>
                  </div>
                </div>
              </Card>
            </div>
          </Card>
        </Page>
        {enableForExceededUser ? (
          <div className="packages packages--expire-exceed">
            <div>
              <div>
                {PACKAGES.map((e, index) => (
                  <PackageCardExpireExceed
                    packageName={e.name}
                    packageNameType={e.name}
                    packageSelected={packageSelected}
                    setPackageSelected={this.handleChangeSelectPackage}
                    packageInfo={e}
                    key={index}
                    index={index}
                    history={history}
                    planNumberRequest={planNumberRequest}
                    packagePlans={packagePlans[e.name]}
                    allPackagePlans={packagePlans}
                    invoice={invoice}
                    currentTotalProducts={currentTotalProducts}
                    confirmationUrl={confirmationUrl}
                    gettingPackage={gettingPackage}
                    gettingInvoice={gettingInvoice}
                    isStoreExceeded={subscriptionStatus === 'exceeded'}
                  />
                ))}
              </div>
              <p>
                {i18n.translate('AdminHTML.SubscriptionV3.Packages.footerCard', {
                  t1: <span>{i18n.translate('AdminHTML.SubscriptionV3.Packages.footer_t1')}</span>
                })}
              </p>
            </div>
          </div>
        ) : (
          <div className="packages">
            <div>
              <div>
                {PACKAGES.map((e, index) => (
                  <PackageCard
                    packageNameType={e.name}
                    packageSelected={packageSelected}
                    setPackageSelected={this.handleChangeSelectPackage}
                    packageInfo={e}
                    key={index}
                    index={index}
                    history={history}
                    planNumberRequest={planNumberRequest}
                    packagePlans={packagePlans[e.name]}
                    allPackagePlans={packagePlans}
                    invoice={invoice}
                    currentTotalProducts={currentTotalProducts}
                    confirmationUrl={confirmationUrl}
                    gettingPackage={gettingPackage}
                    gettingInvoice={gettingInvoice}
                  />
                ))}
              </div>
              <p>
                {i18n.translate('AdminHTML.SubscriptionV3.Packages.footerCard', {
                  t1: <span>{i18n.translate('AdminHTML.SubscriptionV3.Packages.footer_t1')}</span>
                })}
              </p>
            </div>
          </div>
        )}

        <div className="extend-addons">
          <div>
            <p>{i18n.translate('AdminHTML.SubscriptionV3.Packages.extendAddon')}</p>
            <Button primary onClick={this.openAddonPage}>
              {i18n.translate('AdminHTML.SubscriptionV3.Packages.exploreAddonBtn')}
            </Button>
          </div>
        </div>
        <Page>
          <PlansReview />
          <PlansQA />
        </Page>
        <StatusModal
          active={openModalSubscribeFailure}
          infoStatus={contentModalStatus}
          secondaryAction={this.handleSupport}
          handleCancel={() => this.toggleModal('openModalSubscribeFailure')}
        />
      </div>
    );
  }
  // Handle select package
  handleChangeSelectPackage = e => {
    this.setState({ packageSelected: e });
  };

  // Open beacon chat
  handleSupport = () => {
    this.setState({ activeModalStatus: false });
    showBeaconChat();
  };

  // Render current status subscription badge component
  renderStatus = () => {
    const {
      i18n,
      subscription: { status }
    } = this.props;
    const infoStatus = PLAN_STATUS.find(e => e.status === status);
    const { label, type } = infoStatus;
    return (
      <Badge status={type}>
        <span className="title">{i18n.translate(label)}</span>
      </Badge>
    );
  };

  // Handle back to subscription page
  handleBack = () => {
    const { history } = this.props;
    history.push(routes.subscription.plan());
    exitSABFullscreen();
  };

  // Open add on page
  openAddonPage = () => {
    const { history } = this.props;
    history.push(routes.subscription.addon());
  };

  // Toggle modal
  toggleModal = fieldName => {
    const value = this.state[fieldName];
    this.setState({ [fieldName]: !value });
  };
  // Render content modal status error
  renderContentSubscribeError = () => {
    return {
      status: 'error',
      handleAction: () => {
        this.toggleModal('openModalSubscribeFailure');
      }
    };
  };
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  getPackagePlans: () => dispatch(subscriptionV3Action.getPackagePlans(ownProps.i18n)),
  getDetailInvoice: () => dispatch(subscriptionV3Action.getDetailInvoice(ownProps.i18n))
});

const mapStateToProps = (state, props) => {
  const tenantApp = _.get(state.oauth, 'tenantApp', {});
  const packagePlans = _.get(state.subscriptionV3, 'packagePlans', {});

  return {
    tenantApp,
    invoice: _.get(state.subscriptionV3, 'invoice', {}),
    currentTotalProducts: _.get(tenantApp, 'appParams.currentTotalProducts'),
    confirmationUrl: _.get(state.subscriptionV3, 'confirmationUrl', ''),
    subscription: _.get(state.oauth, 'subscription', {}),
    gettingPackage: _.get(state.subscriptionV3, 'gettingPackage', false),
    gettingInvoice: _.get(state.subscriptionV3, 'gettingInvoice', false),
    packagePlans
  };
};

export default withI18n()(connect(mapStateToProps, mapDispatchToProps)(PlanPackage));
